import {ChangeDetectionStrategy, Component, computed, effect, inject, input} from '@angular/core';
import {MatChipsModule} from '@angular/material/chips';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatTableModule} from '@angular/material/table';
import {MatDialog} from '@angular/material/dialog';
import {Store} from '@ngrx/store';
import {ResearchKeywordDTO} from '../../dto/research-keywords';
import {
  selectGenerateLoading,
  selectResearchKeywordState
} from '../../services/research-keyword/research-keyword.selectors';
import {KeywordDialogComponent} from '../keyword-dialog/keyword-dialog.component';
import {generateResearchKeyword, loadResearchKeywords} from '../../services/research-keyword/research-keyword.actions';
import {ConfirmDialogComponent} from '../../../../utils/components/confirm-dialog/confirm-dialog.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltip} from '@angular/material/tooltip';
import {InfoCardComponent} from '../../../../utils/components/info-card/info-card.component';

@Component({
  selector: 'app-keyword-list',
  imports: [
    MatChipsModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatToolbarModule,
    MatProgressBarModule,
    MatTooltip,
    InfoCardComponent
  ],
  templateUrl: './keyword-list.component.html',
  styleUrl: './keyword-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KeywordListComponent {
  private readonly store: Store = inject(Store);
  private readonly dialog: MatDialog = inject(MatDialog);
  readonly projectId = input.required<number>();
  readonly editable = input<boolean>(true);

  private readonly keywordState = this.store.selectSignal(selectResearchKeywordState);
  readonly keywords = computed(() => this.keywordState().keywordsByProject[this.projectId()] ?? []);
  readonly generateLoading = this.store.selectSignal(selectGenerateLoading);
  displayedColumns: string[] = ['and', 'keyword', 'synonyms'];

  constructor() {
    effect(() => {
      this.store.dispatch(loadResearchKeywords({projectId: this.projectId()}));
    });
  }


  genKeywords(): void {
    if (!this.editable()) {
      return;
    }
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      autoFocus: false,
      data: {
        title: 'Generate Keywords',
        message: 'Keywords are generated based on your topic.\nThis can take a while.<br />Do you want to proceed?',
        warningMessage: 'This will replace all old keywords',
        confirmButtonText: 'Replace and Generate',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) return;
      this.store.dispatch(generateResearchKeyword({projectId: this.projectId()!}));
    });

  }


  create(): void {
    if (!this.editable()) {
      return;
    }
    this.dialog.open(KeywordDialogComponent, {
      width: '400px',
      autoFocus: false,
      data: {projectId: this.projectId()},
    });

  }

  openDialog(keyword?: ResearchKeywordDTO): void {
    if (!this.editable()) {
      return;
    }
    this.dialog.open(KeywordDialogComponent, {
      width: '400px',
      autoFocus: false,
      data: {
        projectId: this.projectId(),
        keyword: keyword
      },
    });
  }
}
